<template>
<div class="panel panel-default">

      <div class="panel-body" id="tblUser">

        <div style="padding-top:10px;">
          <div class="col-md-6 col-lg-4 offset-lg-0 item text-center">
            <img src="../assets/user.png" class="rounded-circle" style="width:100px; padding-top:30px" />
            <br/>
            <p>{{userEmail}}</p>
            <hr>
             <img src="../assets/lisk.jpg" class="rounded-circle" style="width:40px; padding-top:10px"/>
             <h4 id="liskMsg"></h4>
              <form id="form" data-toggle="validator" v-on:submit.prevent="saveLiskData" class="text-center">
                <p><input type="text" class="text-center" style="width: 70%; height:30px" id="liskAddress" required></p>
                <button type="submit" class="btn btn-primary" id="load" data-loading-text="<i class='fa fa-spinner fa-spin '></i> Saving ...">Save</button>
              </form>
              <br/>
          </div>
        </div>
</div>

    </div>
</template>

<script>
import firebase from "firebase";
import Vue from "vue";

window.Vue = Vue;
let db = firebase.database();

export default {
  name: "Profile",

  computed: {
    userEmail() {
      return this.$store.state.storeEmail;
    }
  },

  data: function() {
    return {
      users: {
        name: "",
        surname: "",
        currentEmail: ""
      }
    };
  },

  methods: {
    saveLiskData: function() {
      // Controlla sto cazzo di campo Lisk
      var _liskAddress = $("#liskAddress").val();
      //Pulisco il valore da eventuali xss ---------
      var xss = require("xss");
      _liskAddress = xss(_liskAddress);
      //pulizia finita -----------------------------

      if (_liskAddress.length == 21) {
        if (_liskAddress[_liskAddress.length - 1] !== "L") {
          toastr.error(
            "Your Lisk Address is in a bad format! Cannot save this data!"
          );
        } else {
          var userRef;
          let StoredUserId = this.$store.state.storeUid;
          userRef = db
            .ref("users")
            .child(StoredUserId)
            .update({ liskAddress: _liskAddress });
          toastr.success("Your Lisk Address was successfully saved.");
        }
      } else {
        toastr.error(
          "Your Lisk Address is in a bad format! Cannot save this data!"
        );
      }
    },

    checkLiskValue: function() {
      // controllo se esiste un adress Lisk e nel caso lo propongo
      var liskRef;
      let StoredUserId = this.$store.state.storeUid;
      liskRef = db.ref("users").child(StoredUserId);
      liskRef.once("value", function(snapshot) {
        if (snapshot.exists()) {
          if (snapshot.val().liskAddress != null) {
            //alert(snapshot.val().liskAddress);
            // setto il valore di quel campo
            $("#liskMsg").html("Your Lisk Address");
            $("#liskAddress").val(snapshot.val().liskAddress);
          } else {
            $("#liskMsg").html(
              "Do you want to invest with Lisk? <br> Insert your address here!"
            );
          }
        }
      });
    }

    //fine metodi
  },

  mounted() {
    this.checkLiskValue();
    $(".btn").on("click", function() {
      var $this = $(this);
      $this.button("loading");
      setTimeout(function() {
        $this.button("reset");
      }, 6000);
    });
  },

  created() {
    this.users.currentEmail = this.$store.state.storeEmail;
    console.log(this.users.currentEmail);
    let db = firebase.database();
    var usersRef;
    let StoredUserId = this.$store.state.storeUid;
    usersRef = db.ref("users").child(StoredUserId);

    // BINDO I DATI DI FIREBASE SULLA QUERY usersref
    // posso lanciare quasta azione da qui?
    usersRef.once("value", function(snapshot) {
      if (snapshot.exists()) {
        var content = "";
        content += '<div class="col-md-6 col-lg-8 item">';
        content +=
          '<h1 class="text-left" style="color:#335687;">' +
          snapshot.val().name +
          "&nbsp;" +
          snapshot.val().surname +
          "</h1><hr/>";
        content +=
          '<h3 class="text-left">&darr; &nbsp;<b>Your ETH Address</b></h3>';
        content +=
          '<h4 style="word-wrap:break-word" class="text-left"><i class="fab fa-ethereum"></i> &nbsp; ' +
          snapshot.val().ethAddress +
          "<br /></h4>";
        content += "<hr/>";
        content +=
          '<h3 id="idrefcopy" class="text-left">&darr; &nbsp;<b>Invite your friends! Copy and paste the following link</b></h3>';
        content +=
          '<h4 class="text-left"><i class="fas fa-external-link-square-alt"></i> &nbsp; https://whitelist.brikbit.io/#/Register?refid=' +
          snapshot.val().refUser +
          " </h4>";
        content += "<hr/>";
        content += "<br/><br/>";
        content +=
          '<h5><a href="mailto:whitelist@brikbit.io"><i class="fa fa-envelope-o text" style="margin-right:3px"/>need support?</a>';
        content += "</h5>";
        console.log(content);
        $("#tblUser").append(content);
      }
    });
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue